export const canRunBackgroundRefresh = () => {
  const pageIsVisible =
    typeof document === "undefined" || document.visibilityState !== "hidden";
  const browserIsOnline =
    typeof navigator === "undefined" || navigator.onLine !== false;

  return pageIsVisible && browserIsOnline;
};

export const createRecurringTask = (
  callback,
  intervalMs,
  {
    canRun = canRunBackgroundRefresh,
    now = () => Date.now(),
    onError = (error) => console.error("Background refresh failed", error),
  } = {},
) => {
  let timer = null;
  let running = false;
  let stopped = true;
  let lastRunAt = null;

  const clearTimer = () => {
    if (timer !== null) {
      clearTimeout(timer);
      timer = null;
    }
  };

  const schedule = () => {
    clearTimer();
    if (!stopped) timer = setTimeout(run, intervalMs);
  };

  const run = async () => {
    timer = null;
    if (stopped || running) return;

    if (!canRun()) {
      schedule();
      return;
    }

    running = true;
    lastRunAt = now();
    try {
      await callback();
    } catch (error) {
      onError(error);
    } finally {
      running = false;
      schedule();
    }
  };

  return {
    start() {
      if (!stopped) return;
      stopped = false;
      // The caller performs the initial fetch before starting the poller.
      lastRunAt = now();
      schedule();
    },
    runIfDue() {
      if (
        stopped ||
        running ||
        !canRun() ||
        lastRunAt === null ||
        now() - lastRunAt < intervalMs
      )
        return;

      clearTimer();
      run();
    },
    stop() {
      stopped = true;
      clearTimer();
    },
  };
};
